import * as actionsMap from './actions';

export const notifyActionOpenNotification = (push, { lang, syncClose, dispatch }) => {
    const { action, actionId, windowSessionId } = push.data;

    if (!action) {
        return null;
    }

    // assume each push notification can have only one action
    const [actionType, actionInfo] = Object.entries(action)[0] || [];
    const actionHandler = actionsMap[actionType];

    if (!actionType || !actionInfo || !actionHandler) {
        return null;
    }

    return actionHandler({ actionId, actionInfo, windowSessionId, push }, { lang, syncClose, dispatch });
};
